import {
  ENV_QUERY_KEY,
  type Env,
  useEnv,
} from '@sparklayer-io/spark-dash-core/context/env-context';
import { trackIntercomEvent } from '@sparklayer-io/spark-dash-core/lib/intercom';
import { useHandlers, useSite } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OnboardingStepKey } from '../lib/onboarding-steps';

function useHomeApi() {
  const { apis } = useHandlers();
  if (!apis.home) throw new Error('useHomeApi must be used within the dashboard package');
  return apis.home;
}

export function useToggleOnboardingFlag() {
  const homeApi = useHomeApi();
  const { apis } = useHandlers();
  const env = useEnv();
  const site = useSite();
  const queryClient = useQueryClient();

  return useMutation<Env, unknown, { flag: string; key: OnboardingStepKey }>({
    mutationFn: async ({ flag }) => {
      await homeApi.toggleOnboardingFlag(env.team.slugged_name, env.environment, flag);
      return apis.site.env(site.siteId, site.siteEnv);
    },
    onSuccess: (freshEnv, { flag, key }) => {
      queryClient.setQueryData<Env>([ENV_QUERY_KEY, site.siteId, site.siteEnv], freshEnv);
      trackIntercomEvent('updated-onboarding-flag', { flag, new_value: freshEnv[key] });
    },
  });
}
